
























import { Component, Vue, PropSync, Prop } from "vue-property-decorator";

@Component
class Tabs extends Vue {
  @PropSync("value") group!: number;

  @Prop() groups;
}
export default Tabs;
